interface AccountRecoveryOptionsProps {
  onFindId: () => void;
  onResetPassword: () => void;
  className?: string;
}

export function AccountRecoveryOptions({ 
  onFindId, 
  onResetPassword,
  className = '' 
}: AccountRecoveryOptionsProps) {
  
  return (
    <div className={`max-w-md mx-auto space-y-8 ${className}`}>
      {/* 아이디 찾기 버튼 */}
      <button
        onClick={onFindId}
        className="w-full h-[60px] bg-[#DEDEDE] text-[#222222] font-bold text-[20px] rounded-xl hover:bg-[#CECECE] transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300"
      >
        아이디 찾기
      </button>

      {/* 비밀번호 재설정 버튼 */}  
      <button
        onClick={onResetPassword}
        className="w-full h-[60px] bg-[#DEDEDE] text-[#222222] font-bold text-[20px] rounded-xl hover:bg-[#CECECE] transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300"
      >
        비밀번호 재설정
      </button>
    </div>
  );
}